/**
 * @file service.form.tsx
 * @description Форма для создания и редактирования сервисов в системе управления задачами.
 * Включает поля для указания наименования сервиса и порядка сортировки.
 * Порядок сортировки определяет приоритет отображения сервиса в списках и выпадающих меню.
 * Интегрируется с react-hook-form через control prop.
 * @author AI Assistant
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @components/form-controls/text-field, @src/types]
 * @related-files [@components/form-controls/text-field/text-field.component.tsx]
 */

import { TextField } from '@components/form-controls/text-field';
import { BaseForm } from '@src/types';

export const ServiceForm = ({ control }: BaseForm) => {
    return (
        <div className="flex flex-col gap-default w-[33.28182vmin]">
            <TextField name="name" label="Наименование" control={control} />

            <div className="w-[15.59358vmin]">
                <TextField
                    name="order"
                    label="Порядок сортировки"
                    control={control}
                    type="number"
                    incrementButtons={false}
                />
            </div>
        </div>
    );
};
